export const DEFAULT_CUSTOM_ATHLETE_CATEGORY_LIST: string[] = ['custom 1', 'custom 2', 'custom 3', 'custom 4', 'custom 5', 'custom 6'];
